<template>
    <div class="m-resultsDropdown d-flex gap-1 align-items-center">
        <span style="white-space: nowrap">{{ text }}:</span>
        <the-dropdown
            class="mb-0"
            :options="options"
            :selectedOption="perPage.toString()"
            @onChange="setResults($event)"
        ></the-dropdown>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: 'Ilość wyników'
        },
        onChange: {
            type: Function
        },
        perPage: {
            type: Number,
            required: false
        },
        options: {
            type: Array,
            default: () => [10, 25, 50]
        }
    },
    methods: {
        setResults(val) {
            this.onChange(val)
        }
    }
}
</script>
